<section class="suite-technologies-bg">
  <div class="container py-5">
    <div class="section-header text-center mx-auto mb-5">
      <h2>Our Technology Stack for Enterprise-Grade Solutions</h2>
    </div>

    <div class="tech-glass-panel">
      <div class="row align-items-center">

        <!-- Left Column: Text Slider -->
        <div class="col-lg-5 text-content-slider">
          <div class="slider-wrapper">
            <div class="slides-container" [style.transform]="'translateY(' + (-currentSlide * 100) + '%)'">
              <div class="slide-content" *ngFor="let slide of slides">
                <h3 class="slide-title">{{ slide.title }}</h3>
              </div>
            </div>
          </div>
        </div>

        <!-- Right Column: Video Slider -->
        <div class="col-lg-7">
          <div class="image-slider-container">
            <!-- CHANGED: preload="none" to stop downloading all videos at once -->
            <video *ngFor="let slide of slides; let i = index" #videoPlayer [src]="slide.image" class="tech-image"
              [class.active]="i === currentSlide" loop muted playsinline preload="none" disablePictureInPicture
              oncontextmenu="return false;">
            </video>
          </div>
        </div>

      </div>
    </div>

    <!-- Pagination Dots -->
    <div class="pagination-indicators">
      <div *ngFor="let slide of slides; let i = index" class="indicator" [class.active]="i === currentSlide"
        (click)="goToSlide(i)">
      </div>
    </div>

  </div>
</section>